module.exports = __webpack_public_path__ + "media/MRI10A.79737b6f.mp3";